// extracted by mini-css-extract-plugin
export default {"cursor":"Cursor_cursor__PH4Un","name":"Cursor_name__jqTpr"};